export class CpfResponseModel {

    public code: any;
    public application: string;
    public idflow: number;
    public accountHolder: boolean;
    public haveRestrictive: boolean;
    public urlRedirect: any;

    constructor(model?:any) {
        if(!model){return;}
        if (model.application || model.accountHolder || model.haveRestrictive) {
            this.accountHolder = model.accountHolder;
            this.application = model.application;
            this.haveRestrictive = model.haveRestrictive;
            this.idflow = model.idflow
        }

        if (model.idflow === 3) {
            this.accountHolder = true;
        } else if (model.idflow === 4) {
            this.haveRestrictive = true;
        } else if (model.idflow === 5) {
            this.application = 'FOPA';
            this.idflow = model.idflow;
        }
        else{
            this.application = 'OPF';
            this.idflow = model.idflow;
        } 

    }

    public seturlRedirect(url) {
        this.urlRedirect = url; 
    }
}